import { render } from "./Toggle.vue?vue&type=template&id=65329516&scoped=true&ts=true&lang=pug"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=65329516&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65329516"]])

export default __exports__